import { EApiWatchdogFrequencyId } from "utils/watchdog/types";

const resolveDogFreq = (val: string): string => {
  switch (val) {
    case EApiWatchdogFrequencyId.IMMEDIATE:
      return "ihned";
    case EApiWatchdogFrequencyId.ONCE_PER_DAY:
      return "denně";
    case EApiWatchdogFrequencyId.ONCE_PER_WEEK:
      return "týdně";
    default:
      return "denně";
  }
};

export default resolveDogFreq;
